export default "__VITE_PUBLIC_ASSET__623a2cf9__"